import React, { useState } from 'react';
import { Button } from 'reactstrap';
import OnboardDetail from './OnboardDetail';
export default function DetailButton({
  id, LoadGroups
}) {
  const [isUpdating, setIsUpdating] = useState(false);

  return (
    <div>

      <i onClick={() => setIsUpdating(!isUpdating)}
        style={{ cursor: 'pointer' }}
        className="icon-open ml-2 mr-2" >
        <svg fill="none" height="16" viewBox="0 0 24 24" width="16" xmlns="http://www.w3.org/2000/svg"><path d="M10 6H6C4.89543 6 4 6.89543 4 8V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V14M14 4H20M20 4V10M20 4L10 14" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" /></svg>
      </i>

      {isUpdating && (
        <OnboardDetail
          groupId={id}
          visible={isUpdating}
          LoadGroups={LoadGroups}
          toggle={() => setIsUpdating(!isUpdating)}
        />
      )}
    </div>
  );
}
